import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { addToCart } from '../utils/cartUtils';
import { toast } from 'react-toastify';

export default function RecommendedSection() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('Fetching products for RecommendedSection');
    axios
      .get('https://laravel-api.petra-ms.com/api/products')
      .then(response => {
        console.log('API Response:', response.data);
        if (response.data.success) {
          setProducts(response.data.data);
        } else {
          setError('API returned success: false');
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  const handleAddToCart = (product) => {
    const cartItem = {
      id: product.id,
      name: product.product_name,
      price: product.product_price,
      image: `https://laravel-api.petra-ms.com/storage/app/public/${product.product_img}`,
    };
    addToCart(cartItem);
    toast.success(`${product.product_name} added to cart!`, {
      position: "top-right",
      autoClose: 2000,
    });
  };

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">Error: {error}</div>;
  }

  if (products.length === 0) {
    return <div className="text-center py-10">No products available.</div>;
  }

  return (
    <section className="relative py-10">
      <div className="container">
        <div className="text-2xl font-bold text-[#20BCB4] mb-5">Recommended for you</div>
        <Swiper
          slidesPerView={3}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            300: { slidesPerView: 2.5 },
            500: { slidesPerView: 2.5 },
            750: { slidesPerView: 2.5 },
            1000: { slidesPerView: 2.5 },
            1250: { slidesPerView: 2.5 },
          }}
          className="overflow-hidden"
        >
          {products.map((el) => (
            <SwiperSlide key={el.id}>
              <Link
                to={`/items-details/${el.id}`}
                className="w-[350px] flex flex-col bg-white rounded-lg shadow-md overflow-hidden"
              >
                <div className="h-[300px] p-[20px] border-b-[1px] border-b-[#20bcb4]">
                  <img
                    className="w-full h-full object-contain"
                    src={`https://laravel-api.petra-ms.com/storage/app/public/${el.product_img}`}
                    alt={el.product_name}
                    onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
                  />
                </div>
                <div className="p-4 flex flex-col gap-[15px] justify-between">
                  <div className="flex flex-col gap-[2px]">
                    <div className="flex items-center justify-between">
                      <div className="font-bold text-[20px] capitalize">
                        {el.product_name}
                      </div>
                      <div className="flex items-center gap-[4px]">
                        <img
                          className="w-[15px] h-[15px]"
                          src={require('../../assets/icons/star.svg').default}
                          alt=""
                        />
                        <div className="font-bold">
                          {el.rate ? `${el.rate}/5` : 'N/A'}
                        </div>
                      </div>
                    </div>
                    <div className="capitalize text-[#a8a8a8]">
                      {el.category?.category_name || 'Unknown'}
                    </div>
                  </div>
                  <div className="flex items-center gap-[4px]">
                    <div className="text-center font-bold">
                      {el.product_price} {el.product_currency}
                    </div>
                    |
                    <div className="text-[#a8a8a8] capitalize">
                      {el.product_availability || 'N/A'}
                    </div>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault(); // منع الانتقال عند الضغط
                      handleAddToCart(el);
                    }}
                    className="bg-[#20bcb4] p-2 rounded font-bold text-white capitalize"
                  >
                    Add to cart
                  </button>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}